import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { GitCompareArrowsIcon, XIcon } from 'lucide-react';
import { Car } from '../types/car';
import { thumbUrl } from '../utils/image';
interface CompareTrayProps {
  cars: Car[];
  max: number;
  onRemove: (id: string) => void;
  onClear: () => void;
  onCompare: () => void;
}
export function CompareTray({
  cars,
  max,
  onRemove,
  onClear,
  onCompare
}: CompareTrayProps) {
  const canCompare = cars.length >= 2;
  return <AnimatePresence data-id="element-205" data-mp="1n4eiywt13i6y">
      {cars.length > 0 && <motion.aside aria-label="Vehículos para comparar" className="fixed inset-x-0 bottom-0 z-40 border-t border-neon/40 bg-panel" initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-206" data-mp="1n5xxoiz1dl6m">
          <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3 sm:px-6 lg:px-8" data-id="element-207" data-mp="33h1tfnvfxpwz">
            <ul className="flex min-w-0 flex-1 items-center gap-2 overflow-x-auto" data-id="element-208" data-mp="38fmx5x9wirq6">
              {cars.map(car => <li key={car.id} className="flex shrink-0 items-center gap-2 rounded-lg border border-line bg-ink py-1 pl-1 pr-2" data-id="element-209" data-mp="1wjs3o4armlh6">
                  <img src={thumbUrl(car.image, 160)} alt="" className="h-9 w-12 rounded-md object-cover" data-id="element-210" data-mp="2a9lq6fysstnq" />
                  <span className="whitespace-nowrap text-xs font-medium text-white" data-id="element-211" data-mp="25cdi587d6607">{car.model}</span>
                  <button type="button" onClick={() => onRemove(car.id)} aria-label={`Quitar ${car.model}`} className="flex h-6 w-6 items-center justify-center rounded text-muted transition-colors duration-150 hover:text-neon focus:outline-none focus-visible:ring-2 focus-visible:ring-neon" data-id="element-212" data-mp="1hmrhshf99kqm">
                    <XIcon className="h-3.5 w-3.5" data-id="element-213" data-mp="32yax4vmjbt7e" />
                  </button>
                </li>)}
              {Array.from({
            length: max - cars.length
          }).map((_, i) => <li key={`slot-${i}`} className="hidden h-11 w-28 shrink-0 items-center justify-center rounded-lg border border-dashed border-line text-xs text-muted sm:flex" data-id="element-214" data-mp="3605n773fra3v" data-mpi={i}>
                  Agregar
                </li>)}
            </ul>
            <button type="button" onClick={onClear} className="hidden whitespace-nowrap text-sm text-muted transition-colors duration-150 hover:text-white sm:block" data-id="element-215" data-mp="3jznafi132fb4">
              Limpiar
            </button>
            <button type="button" onClick={onCompare} disabled={!canCompare} title={canCompare ? undefined : 'Elegí al menos 2 vehículos'} className="flex h-11 shrink-0 items-center gap-2 whitespace-nowrap rounded-lg bg-neon px-4 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-neon-bright disabled:cursor-not-allowed disabled:opacity-40 focus:outline-none focus-visible:ring-2 focus-visible:ring-neon" data-id="element-216" data-mp="2wavsrkl4dfcl">
              <GitCompareArrowsIcon className="h-4 w-4" aria-hidden="true" data-id="element-217" data-mp="1w2xqugpmijne" />
              Comparar ({cars.length})
            </button>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}